import { DriverApplication } from 'shared/components/Onboarding/DriverApplication/DriverApplication'
import { Text } from 'shared/components/Text/Text'
import { Handler } from 'shared/helpers/typeHelper'
import { useOnboardingChecklist } from 'shared/hooks/query/useOnboardingChecklist'
import { User } from 'shared/models/user'

import { AppLayout } from '../AppLayout/AppLayout'
import { AppOnboardingFlow } from './UserCtonCtProfile'
import { UserEmploymentHistoryOnboarding } from './UserEmploymentHistoryOnboarding'

interface UserAppOnboardingProps {
  user: User
  onClose: Handler
  appOnboardingFlow: AppOnboardingFlow
}

export function UserAppOnboarding({ user, onClose, appOnboardingFlow }: UserAppOnboardingProps) {
  const { refetch } = useOnboardingChecklist(user.id, { enabled: false })

  async function handleRedirect() {
    await refetch()
    onClose()
  }

  function renderContent() {
    if (appOnboardingFlow === AppOnboardingFlow.DRIVER_APPLICATION) {
      return <DriverApplication user={user} handleRedirect={handleRedirect} />
    }
    if (appOnboardingFlow === AppOnboardingFlow.EMPLOYMENT_HISTORY) {
      return <UserEmploymentHistoryOnboarding user={user} handleRedirect={handleRedirect} />
    }
    return null
  }

  return (
    <AppLayout
      onClose={onClose}
      navBar={
        <Text variant="paragraph2">
          Entering information for{' '}
          <strong>
            {user.firstName} {user.lastName}
          </strong>
        </Text>
      }
    >
      {renderContent()}
    </AppLayout>
  )
}
